"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegFb = void 0;
const base_1 = require("./base");
const fb_1 = require("../services/fb");
/**
 * Fb Pixel
 */
class AnIntegFb extends base_1.AnIntegBase {
    static isLoaded() {
        return fb_1.AnServFb.isLoaded();
    }
    static sendInit(siteCategory, userId, email, coupon) {
        fb_1.AnServFb.sendInit(this.getPixelId(siteCategory), null, null, null);
        return true;
    }
    static sendPage(siteCategory, userId, email) {
        if (userId !== null && email !== null) {
            fb_1.AnServFb.sendIdentify(this.getPixelId(siteCategory), userId, email);
        }
        fb_1.AnServFb.sendPage(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackQuizStartLegacy(siteCategory) {
        return this.sendTrackQuizStart(siteCategory);
    }
    static sendTrackQuizStart(siteCategory) {
        fb_1.AnServFb.sendStdEventViewContent("Quiz Start");
        return true;
    }
    static sendTrackClubCheckoutStart(siteCategory) {
        fb_1.AnServFb.sendStdEventAddToCart(this.getPixelId(siteCategory), "Survey Complete");
        return true;
    }
    static sendTrackArriveSignupLoginLegacy(siteCategory) {
        fb_1.AnServFb.sendStdEventAddToCart(this.getPixelId(siteCategory), "Survey Complete");
        return true;
    }
    static sendTrackClubAccountCreate(siteCategory, userId, email) {
        fb_1.AnServFb.sendIdentify(this.getPixelId(siteCategory), userId, email);
        fb_1.AnServFb.sendStdEventLead(this.getPixelId(siteCategory), "Checkout");
        return true;
    }
    static sendTrackClubAccountCreateLegacy(siteCategory, userId, email) {
        return this.sendTrackClubAccountCreate(siteCategory, userId, email);
    }
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        fb_1.AnServFb.sendStdEventPurchaseSubscription(this.getPixelId(siteCategory), userId, price, "Order  Confirm Page", coupon);
        fb_1.AnServFb.sendStdEventSubscribe(this.getPixelId(siteCategory), price);
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        return this.sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon);
    }
    static sendTrackClubRejoinLegacy(siteCategory, userId, email, price) {
        fb_1.AnServFb.sendCustEvent(this.getPixelId(siteCategory), "ReSubscribe", {
            user_id: userId,
            content_name: "Subscription Rejoin"
        });
        return true;
    }
    static sendTrackEcommAccountCreate(siteCategory, userId, email) {
        fb_1.AnServFb.sendIdentify(this.getPixelId(siteCategory), userId, email);
        fb_1.AnServFb.sendStdEventLead(this.getPixelId(siteCategory), "Checkout");
        return true;
    }
    static sendTrackEcommAddPaymentInfo(siteCategory) {
        fb_1.AnServFb.sendStdEventAddPaymentInfo(this.getPixelId(siteCategory));
        return true;
    }
    static sendTrackEcommThankyou(siteCategory, userId, orderId, price, coupon) {
        fb_1.AnServFb.sendStdEventPurchaseProduct(this.getPixelId("ecomm"), userId, orderId, price, coupon);
        return true;
    }
    static sendTrackEcommProductView(siteCategory, productId) {
        fb_1.AnServFb.sendStdEventViewContent(this.getPixelId("ecomm"), null, "product_group", [productId.toString()]);
        return true;
    }
    static sendTrackEcommProductAddToCart(siteCategory, productId) {
        fb_1.AnServFb.sendStdEventAddToCart(this.getPixelId("ecomm"), null, [productId.toString()]);
        return true;
    }
}
exports.AnIntegFb = AnIntegFb;
AnIntegFb.shouldSendIfNoConsent = true;
AnIntegFb.shouldSendEveryPage = true;
AnIntegFb.shouldSendTrackQuizStart = true;
AnIntegFb.shouldSendTrackQuizStartLegacy = true;
AnIntegFb.shouldSendTrackClubCheckoutStart = true;
AnIntegFb.shouldSendTrackArriveSignupLoginLegacy = true;
AnIntegFb.shouldSendTrackClubAccountCreate = true;
AnIntegFb.shouldSendTrackClubAccountCreateLegacy = true;
AnIntegFb.shouldSendTrackClubThankyou = true;
AnIntegFb.shouldSendTrackClubThankyouLegacy = true;
AnIntegFb.shouldSendTrackClubRejoinLegacy = true;
AnIntegFb.shouldSendTrackEcommAccountCreate = true;
AnIntegFb.shouldSendTrackEcommAddPaymentInfo = true;
AnIntegFb.shouldSendTrackEcommThankyou = true;
AnIntegFb.shouldSendTrackEcommProductView = true;
AnIntegFb.shouldSendTrackEcommProductAddToCart = true;
AnIntegFb.pixelId = {
    prod: {
        defaultId: "289866896000930",
        ecomm: "289866896000930",
        club: "401518973376931",
    },
    dev: {
        defaultId: "289866896000930",
        ecomm: "289866896000930",
        club: "401518973376931",
    },
};
